module.exports = __webpack_public_path__ + "static/media/map.80ec8152.svg";